"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FocusedImageMethods = require("./FocusedImageMethods");
var _propTypes = _interopRequireWildcard(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FocusedImage = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _FocusedImageMethods.renderFocusedImage)(props));
};
var _default = FocusedImage;
exports.default = _default;
FocusedImage.propTypes = {
  focalPointImage: _propTypes.default.object,
  alt: _propTypes.default.string,
  imageSizes: _propTypes.default.shape({
    desktop: _propTypes.default.object,
    tablet: _propTypes.default.object,
    mobile: _propTypes.default.object,
    ratio: _propTypes.default.shape({
      width: _propTypes.number,
      height: _propTypes.number
    })
  }),
  fullHeightWrapper: _propTypes.default.bool,
  quality: _propTypes.default.number
};